<div #anchor class="date-range-picker" [ngClass]="{'disabled': disabled}" (click)="!disabled && openDatePickerPopup($event)">
	<div class="date-range-picker-display" title="{{dateRange.from|cpDate}} - {{dateRange.to|cpDate}}">{{dateRange.from|cpDate}} - {{dateRange.to|cpDate}}</div>
	<div class="date-range-picker-calendar-button">
		<i class="k-icon k-i-calendar"></i>
	</div>
</div>

<kendo-popup
		class="cp-date-range-picker-component-popup"
		[anchor]="anchor"
		*ngIf="isDatePickerPopupOpened">
	<div cpClickOut
		 (clickOut)="closeDatePickerPopupOnClickOutSide($event)">
		<cp-date-range-picker-calendar
			[dateRange]="dateRange"
			[disabled]="disabled"
			(onChange)="handleSelectionRangeChange($event)">
		</cp-date-range-picker-calendar>
	</div>
</kendo-popup>
